import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { CloseOverlayService } from '../../_services/closeOverlay.service';

@Component({
  selector: 'app-not-allowed',
  templateUrl: './not-allowed.page.html',
  styleUrls: ['./not-allowed.page.scss'],
})
export class NotAllowedPage implements OnInit {
  subscription: any;

  constructor(
    private modalCtrl: ModalController, private platform: Platform,
    private location: Location, private closeOverlayService: CloseOverlayService
  ) { }

  dismiss() {
    this.modalCtrl.dismiss({
      dismissed: true
    });
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      if (this.constructor.name === 'NotAllowedPage') {
        this.closeOverlayService.trigger();
      } else {
        this.location.back();
      }
    });
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
  }

}
